import { graphql } from '@/gql';
import type { CheckRetentionLinkByPhoneNumberMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const checkRetentionLinkByPhoneNumber = async (
  variables: CheckRetentionLinkByPhoneNumberMutationVariables,
) => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CheckRetentionLinkByPhoneNumber($code: String!, $phoneNumber: String!) {
        checkRetentionLinkByPhoneNumber(code: $code, phoneNumber: $phoneNumber)
      }
    `),
    variables,
  });

  return response.data?.checkRetentionLinkByPhoneNumber;
};
